// 1. Core Rails
import Rails from "@rails/ujs"
Rails.start()

import Turbolinks from "turbolinks"
Turbolinks.start()

import "@rails/activestorage"
import "channels"
import localTime from "local-time"
localTime.start()

// 2. jQuery, Popper, Moment
import $ from "jquery"
import Popper from "popper.js"
import moment from "moment"

window.$ = window.jQuery = $
window.Popper = Popper
window.moment = moment

// 3. Bootstrap 4 plugins (EXPLICIT)
import "bootstrap/js/dist/modal"
import "bootstrap/js/dist/tooltip"
import "bootstrap/js/dist/popover"
import "bootstrap/js/dist/dropdown"

// 4. DataTables CORE (EXPLICIT jQuery binding)
import dt from "datatables.net-bs4"
dt(window, $)

// 5. DataTables EXTENSIONS (SAFE now)
import "datatables.net-fixedcolumns-bs4"
import "datatables.net-colreorder-bs4"
import "datatables.net-select-bs4"

import "../datatables_dates"
import "../datatables"

// 6. Third-party libs
import "chartkick"
import "chart.js"
import "jquery.easy-autocomplete"

import Highcharts from "highcharts"
window.Highcharts = Highcharts

// 7. data-confirm-modal (Bootstrap dependency satisfied)
import "data-confirm-modal"

// 8. Local Plaza JS
import "../spider_charts"
import "../cloud_charts"
import "../village_form"
import "../village"
import "../maps"
import "../search"
import "../invoices"
import "../turbolinks_csp_nonce"
import "../generate_invoice"
import "../recaptcha_fallback"

// 9. UI activation
document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
})

